import { Navigate, Routes, Route } from "react-router-dom";
import { LoginPage } from "@/features/auth/LoginPage";
import { LoggedOutPage } from "@/features/auth/LoggedOutPage";
import { OIDCCallbackPage } from "@/features/auth/OIDCCallbackPage";
import { ProtectedRoute } from "@/features/auth/ProtectedRoute";
import { ShellLayout } from "@/components/layout/ShellLayout";
import { ShellRouter } from "@/features/shell/ShellRouter";
import { hubRoutes } from "@/app/hub-routes";

import { Toaster } from "@/components/ui/sonner";

export default function App() {
  /* Hub v2.5 is an unreleased prototype: it stays unmounted unless the build
     opts in explicitly. Any other value (including unset) keeps it off. */
  const hubEnabled = import.meta.env.VITE_ENABLE_HUB === "true";

  return (
    <>
      <Toaster />
      <Routes>
        <Route path="/login/:orgSlug?" element={<LoginPage />} />
        <Route path="/logged-out" element={<LoggedOutPage />} />
        <Route path="/auth/oidc/callback" element={<OIDCCallbackPage />} />
        {/* Hub v2.5 routes — prototype design system screens (protected) */}
        {hubEnabled ? (
          <Route element={<ProtectedRoute />}>{hubRoutes}</Route>
        ) : (
          <Route path="/hub/*" element={<Navigate to="/" replace />} />
        )}
        <Route
          element={
            <ProtectedRoute>
              <ShellLayout />
            </ProtectedRoute>
          }
        >
          {/* All existing authenticated routes are handled by ShellRouter */}
          <Route path="/*" element={<ShellRouter />} />
        </Route>
      </Routes>
    </>
  );
}
